module.exports = "<ng-container>\n  <contact-us></contact-us>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/form-container/form-container.component.html
// module id = 880
// module chunks = 2